/**
 * The legal limit for adult female lice per fish: the reference line in the lice count chart, and
 * the top of the OrbitOne heatmap's colour scale for adult female lice. The limit currently takes
 * one of two values, 0.2 or 0.5; both widgets use 0.5 for now.
 */
export const ADULT_FEMALE_LICE_REFERENCE_VALUE = 0.5;
